

















import Vue from 'vue'
import { Sidebar, Toolbar } from '@/components/partials/'

export default Vue.extend({
  components: {
    Sidebar,
    Toolbar,
  },
  computed: {
    isLoading(): boolean {
      return this.$store.getters['app/loading']
    },
  },
})
